import React from "react"
import Layout from "../components/Layout"
import SEO from "../components/seo"
import Skills from "../components/Skills"

export default function products() {
  return (
    <Layout>
      <SEO
        title="Criador de Sites e Aplicativos"
        lang="en"
        description="Desenvolvedor de Sites e Aplicativos.Front End.Mobile.Web Designer.Criador de Sites em Goiânia"
      />
      <Skills />
    </Layout>
  )
}
